// import external dependencies
// import 'jquery';
import './vueApp';

import './gutenberg/gutenberg-blocks';

// Import everything from autoload


// import local dependencies
import './layout/overlay-menu';
import './layout/common';
import './layout/slider';
import './layout/animations';



// WEBPACK FOOTER //
// ./scripts/main.js